import _ from 'lodash';
import * as types from './types';

const initialState = {
  loading: null,
  error: null,
  geographies: [],
  loaded: false,
  currentGeography: null,
  geographyOptions: {
    location: [],
    college_credit_types: [],
    filterable_education_philosophy: [],
    classroom_type: [],
    minimum_age: [],
    benefits: [],
    trainings: [],
  },
};

const geographiesReducer = (state = _.cloneDeep(initialState), { type, payload, errors }) => {
  switch (type) {
    case types.GEOGRAPHIES_LOAD_START:
      return {
        ...state,
        loading: true,
      };
    case types.GEOGRAPHY_OPTIONS_LOAD_SUCCESS: {
      let geographyOptions = _.cloneDeep(initialState.geographyOptions);
      const notApplicables = payload.filter(
        (option) => option.title?.toLowerCase() === 'not applicable',
      );
      const sortedGeoOptions = _.sortBy(
        payload.filter((option) => option.title?.toLowerCase() !== 'not applicable'),
        ['title'],
      );
      [...notApplicables, ...sortedGeoOptions].forEach((option) =>
        geographyOptions[option.category]?.push(option),
      );
      return {
        ...state,
        geographyOptions,
      };
    }
    case types.GEOGRAPHIES_LOAD_SUCCESS:
      return {
        ...state,
        geographies: payload,
        loading: false,
        loaded: true,
      };
    case types.GEOGRAPHIES_LOCATIONS_LOAD_SUCCESS:
      return {
        ...state,
        locations: payload,
      };
    case types.GEOGRAPHY_SUGGESTED_LOAD_SUCCESS:
      return {
        ...state,
        suggestedGeography: payload,
      };
    case types.GEOGRAPHIES_LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        loaded: false,
      };
    case types.CURRENT_GEOGRAPHY_LOAD_START:
      return {
        ...state,
        loading: true,
      };

    case types.CURRENT_GEOGRAPHY_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        currentGeography: payload,
      };
    case types.CURRENT_GEOGRAPHY_LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        loaded: false,
      };
    default:
      return state;
  }
};

export default geographiesReducer;
